<div class="stepper-container" data-cy="stepper" data-variant="variant3">
  <div
    class="stepper-keys"
    [style]="{
      color: config().body.progressbar.labelColor,
      fontFamily: config().body.progressbar.labelFontFamily,
    }"
  >
    <p class="earn">
      {{ config().body.progressbar.earnLabel }}
    </p>
    <p class="spend">
      {{ config().body.progressbar.spendLabel }}
    </p>
  </div>

  <div
    class="progress-bar-container"
    [style.left]="config().body.progressbar.progressBarLeft"
  >
    <div
      class="progress-bar"
      [style]="{
        left: config().body.progressbar.progressBarLeft,
        backgroundColor: config().body.progressbar.containerColor,
      }"
    ></div>
    <div
      data-cy="progress-bar"
      class="progress-bar-value"
      [style]="{
        width: challenge() | progressWidth: limitsPerNbSteps,
        backgroundColor: config().body.progressbar.progressColor,
      }"
    ></div>
  </div>

  <ul
    class="steps steps-container"
    [style.left]="
      challenge().targets.length === 1
        ? '160px'
        : challenge().targets.length === 2
          ? '40px'
          : '8px'
    "
  >
    @for (item of challenge().targets; track i; let i = $index) {
      @let stepStatus = challenge() | stepStatus: i;
      <li
        class="stepper-item"
        [class]="stepStatus"
        [style.marginRight]="
          challenge().targets.length === 2 && i === 0 ? '40px' : 0
        "
      >
        <div
          class="reward-container"
          data-cy="active_step_img"
          [class]="stepStatus"
        >
          @if (
            config().body.rewards.activePicto &&
            stepStatus === StepStatus.REACHED
          ) {
            <img
              alt=""
              class="picto-active"
              [src]="config().body.rewards.activePicto"
            />
          }
          <div
            b2cSvg
            class="bubble"
            [style.width]="config().body.rewards.backgroundColors.bubbleWidth"
            [style.minHeight]="
              config().body.rewards.backgroundColors.bubbleHeight
            "
            [alt]="
              config().body.rewards.backgroundColors.alternativeText[stepStatus]
                | replaceVars: challenge().steps[i].reward
            "
            [width]="config().body.rewards.backgroundColors.bubbleWidth"
            [fill]="config().body.rewards.backgroundColors[stepStatus].fill"
            [svgPath]="config().body.rewards.backgroundColors.backgroundImage"
            [stroke]="config().body.rewards.backgroundColors[stepStatus].stroke"
          ></div>

          <div
            class="label-reward"
            [style.flexDirection]="config().body.rewards.flexDirection"
          >
            <div
              class="step-reward-container"
              [class]="config().body.rewards.rewardClass"
            >
              <div
                class="step-reward"
                [style]="{
                  color:
                    config().body.rewards.backgroundColors[stepStatus]
                      .textColor,
                  fontSize: config().body.rewards.fontSize,
                  fontStyle: config().body.rewards.fontStyle,
                  fontFamily: config().body.rewards.fontFamily,
                }"
                [innerHTML]="challenge().steps[i].reward | formatReward | safe"
              ></div>

              <p
                class="reward-unit-text"
                [style]="{
                  color:
                    config().body.rewards.backgroundColors[stepStatus]
                      .rewardUnitTextColor,
                  fontFamily: config().body.rewards.fontFamily,
                }"
              >
                {{ config().body.rewards.rewardUnitText }}
              </p>
            </div>
            <p
              class="step-wording"
              [style]="{
                color:
                  config().body.rewards.backgroundColors[stepStatus].labelColor,
                fontFamily:
                  config().body.rewards.labelFontFamily ??
                  config().body.rewards.fontFamily,
              }"
            >
              @if (stepStatus === StepStatus.DEFAULT) {
                {{ config().body.rewards.passedLabel }}
              } @else {
                {{ config().body.rewards.activeLabel }}
              }
            </p>
          </div>
          <div class="step-progressbar">
            <div
              class="step-circle"
              data-cy="step_reached"
              [class]="stepStatus"
            >
              @if (stepStatus === StepStatus.REACHED) {
                <img
                  [alt]="
                    config().body.progressbar.pictureStageReached
                      .alternativeText
                  "
                  class="responsive-width"
                  [src]="config().body.progressbar.pictureStageReached.imageUrl"
                />
              }
            </div>
          </div>
        </div>
        <div
          class="step-target"
          [class]="stepStatus"
          data-cy="target_reached"
          [style]="{
            color: config().body.targets.color,
            fontFamily: config().body.targets.fontFamily,
            textDecoration:
              stepStatus !== StepStatus.UNREACHED
                ? config().body.targets.textDecorationOnReached || 'none'
                : 'none',
          }"
        >
          {{ item | formatAmount: 'currency' : 0 }}
        </div>
      </li>
    }
  </ul>
</div>
